// ink-component
import React, { ReactNode } from 'react';
import { StrictModifiers } from '@popperjs/core';

import { Tooltip } from '../../../Tooltip/Tooltip';
import RenderedProp from './RenderedProp';

export interface DropdownTooltipProps {
  /** Tooltip content node */
  children: ReactNode;
  /** Tooltip trigger element - usually a Dropdown.Button, Dropdown.Anchor, or any other component - as a render prop */
  render: (props: any) => ReactNode;
  /** The direction the tooltip will be opened */
  placement?: 'right' | 'left' | 'top' | 'bottom';
  /** Customize the Tooltip behavior passing an array to configure
   * any of the **prebuilt** Popper v2 modifiers:
   * https://popper.js.org/docs/v2/constructors/#modifiers */
  modifiers?: StrictModifiers[];
  /** Removes time delay between trigger losing hover/focus and the dismissal of the tooltip content */
  noDelay?: boolean;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

/**
 * @purpose A tooltip to be used along with Dropdown.Item(s)
 * @categories navigation
 * @group Dropdown
 */
const DropdownTooltip = (props: DropdownTooltipProps) => {
  const { children, render, placement, modifiers, noDelay, 'data-testid': testId, ...otherProps } = props;

  return (
    <Tooltip
      {...props}
      triggerIsBlock
      preventClickPersist
      noDelay={noDelay}
      trigger={<RenderedProp {...otherProps} render={props.render(otherProps)} />}
    />
  );
};

DropdownTooltip.defaultProps = {
  placement: undefined,
  modifiers: [],
  'data-testid': undefined,
};

DropdownTooltip.displayName = 'Dropdown.Tooltip';

export default DropdownTooltip;
